<template>
    <span id="add-account">
        <el-button
            v-if="!isEditMode"
            id="add-account"
            class="button-action-default"
            size="mini"
            type="success"
            plain
            @click="dialogVisible = true"
        >
    {{ $t('account.contactInfo.addContactTitle') }}
  </el-button>
  <i  v-if="isEditMode" class="el-icon-edit header-info-dialog-value icon-action" id="btn-unit-detail" @click="toggleVisible" size="mini" icon="el-icon-plus"></i>

  <el-dialog
      id="add-tariff-dialog"
      :title="isEditMode ? '' : $t('account.contactInfo.addContactTitle')"
      :visible.sync="dialogVisible"
      width="70%"
      class="dialog-with-cols"
      :close-on-click-modal="false"
      append-to-body
      :before-close="closeDialog"
    >

    <el-form v-if="dialogVisible" :model="form" :rules="formRules" ref="form" label-position="top" size="mini">

          <el-row>

            <!--Account Name  -->
            <el-col :span="12" class="form-vertical-item">
              <el-form-item :label="$t('account.contactInfo.name')" prop="name" ref="name">
                <el-input v-model="form.name" :placeholder="$t('account.contactInfo.name')" />
              </el-form-item>
            </el-col>
            <!-- Account Type -->
            <el-col :span="12" class="form-vertical-item">
              <el-form-item :label="$t('account.contactInfo.type')" prop="roles" ref="type">
              <select-list-billing
                  :value.sync="form.roles"
                  :data="contactTypes"
                  label-field="label"
                  value-field="value"
                  ref="filter-region-select" />
              </el-form-item>
            </el-col>

        </el-row>

          <el-row>

            <!--Account Email  -->
            <el-col :span="12" class="form-vertical-item">
              <el-form-item :label="$t('account.contactInfo.email')" prop="email" ref="email">
                <el-input v-model="form.email"  :placeholder="$t('account.contactInfo.email')" />
              </el-form-item>
            </el-col>
            <!-- Account Aditional Email -->
            <el-col :span="12" class="form-vertical-item">
              <el-form-item :label="$t('account.contactInfo.additionalEmail')" prop="additionalEmail" ref="additionalEmail">
                <el-input v-model="form.additionalEmail"  :placeholder="$t('account.contactInfo.additionalEmail')" />
              </el-form-item>
            </el-col>

        </el-row>

        <el-row>

          <!--Account Phone  -->
          <el-col :span="12" class="form-vertical-item">
            <el-form-item :label="$t('account.contactInfo.phone')" prop="phone" ref="phone">
              <el-input v-model="form.phone"  :placeholder="$t('account.contactInfo.phone')" />
            </el-form-item>
          </el-col>
          <!-- Account Aditional Phone -->
          <el-col :span="12" class="form-vertical-item">
            <el-form-item :label="$t('account.contactInfo.additionalPhone')" prop="additionalPhone" ref="additionalPhone">
              <el-input v-model="form.additionalPhone"  :placeholder="$t('account.contactInfo.additionalPhone')" />
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>

          <!--Account Active  -->
          <el-col :span="12" class="form-vertical-item">
            <el-form-item :label="$t('account.contactInfo.active')" prop="active" ref="active">
              <el-checkbox v-model="form.active"  :placeholder="$t('account.contactInfo.active')" />
            </el-form-item>
          </el-col>

        </el-row>


    </el-form>
    <div
          id="add-day-of-service-dialog-footer"
          slot="footer"
          class="dialog-footer form-vertical-item flex-reverse-direction"
        >
          <el-button
            type="primary"
            id="save-storage-location-button"
            @click="submitForm()"
            size="mini"
          >{{ $t('common.save') }}</el-button>
          <el-button
            id="refresh-storage-location-button"
            @click="isEditMode ? fillForm() : resetForm()"
            size="mini"
          >{{ $t('common.clear') }}</el-button>
        </div>
  </el-dialog>
    </span>
</template>

<script>
import { mapGetters } from 'vuex';
import { CONTACT_INFO_SAVE, ACCOUNT_SEARCH_CONTACT_INFO } from '@/store/actions';
import { Message } from 'element-ui';
import constants from '@/utils/constants';
import SelectListBilling from '@/components/billing/SelectListBilling/SelectListBilling';


export default {
  name: 'AddAccount',
  components: {
    SelectListBilling
  },
  data() {
    return {
      dialogVisible: false,
      isBillingNameEdited: false,
      contactTypes: constants.ACCOUNTS.CONTACT_TYPES,
      form: {
        id: null,
        name: null,
        roles: null,
        email: null,
        phone: null,
        additionalEmail: null,
        additionalPhone: null,
        active: true,
      },
      formRules: {
        roles: [
          {
            required: true,
            message: this.$t('account.error.fieldRequired'),
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('account.error.fieldRequired'),
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: false,
            message: this.$t('account.error.fieldRequired'),
            trigger: 'blur'
          }
        ],
        phone: [
          {
            required: false,
            message: this.$t('account.error.fieldRequired'),
            trigger: 'blur'
          }
        ]
      }
    };
  },
  props: {
    account: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters(['customerMasterRecord']),
    isEditMode() {
      return this.account && Object.keys(this.account).length > 0;
    },
    accountId() {
      return this.customerMasterRecord.list && this.customerMasterRecord.list.length
        ? this.customerMasterRecord.list[0].id
        : null;
    }
  },
  methods: {
    closeDialog() {
      this.dialogVisible = false;
      this.resetForm();
    },
    toggleVisible() {
      this.dialogVisible = !this.dialogVisible;
      if (this.dialogVisible) {
        this.$nextTick(() => this.fillForm());
      }
    },
    formatPhoneNumber() {
      const phoneNumber = this.form.phone.replace(/\D/g, '');

      if (phoneNumber.length > 0) {
        if (phoneNumber.length <= 3) {
          this.form.phone = phoneNumber;
        } else if (phoneNumber.length <= 6) {
          this.form.phone = `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
        } else {
          this.form.phone = `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
        }
      }
    },
    resetForm() {
      this.form.id = null;
      this.form.name = null;
      this.form.type = null;
      this.form.roles = null;
      this.form.email = null;
      this.form.phone = null;
      this.form.additionalEmail = null;
      this.form.additionalPhone = null;
      this.form.active = true;
    },
    async submitForm() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            Message.closeAll();
            const { id, number } = this.customerMasterRecord.list[0];
            this.form.accountId = id;
            this.form.accountNumber = number;
            this.form.type = this.form.roles;
            const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
            this.form.type = this.form.roles;

            this.$store.dispatch(CONTACT_INFO_SAVE, this.form)
              .then((response) => {
                loading.close();
                if (response && response.message) {
                  this.$message.success(response.message);
                }
                this.closeDialog();
                this.$store.dispatch(ACCOUNT_SEARCH_CONTACT_INFO, { accountId: id });
                this.closeDialog();
                resolve(response);
              })
              .catch((error) => {
                loading.close();
                resolve(error);
              });
          } else {
            resolve(new Error(this.$t('common.invalid')));
          }
        });
      });
    },
  },
};
</script>
